const fitSuccess = document.querySelector('#will-fit-btn');
    const fitDanger = document.querySelector('#will-not-fit-btn');
    const mobileFitSuccess = document.querySelector('#will-fit-mobile');
    const mobileFitDanger = document.querySelector('#will-not-fit-mobile');
    const bikeNameDisplay = document.querySelector('#bike-name');
    const bikeRemoveMobile = document.querySelector('#bike-remove-mobile');

document.addEventListener('DOMContentLoaded', () => {
    updateFitmentInfo();
    window.addEventListener('resize', updateFitmentInfo);
});

function updateFitmentInfo() {
    const productFitment = document.querySelector('.product-fitment').textContent.slice(0,7);
    const productType = document.querySelector('.product-type').textContent;
    const fit = productFitment && sessionStorage.getItem('fitments') ? sessionStorage.getItem('fitments').replaceAll('&amp;', '&').includes(productFitment) : false;
    // console.log(productFitment, productType, fit)

    // Selectors
    

    // Initial setup: Hide all buttons
    [fitSuccess, fitDanger, mobileFitSuccess, mobileFitDanger].forEach(btn => btn.classList.remove('btn-show'));

    if (sessionStorage.getItem('bikeName')) {
        bikeNameDisplay.innerHTML = sessionStorage.getItem('bikeName');
        // Toggle mobile button based on viewport width
        bikeRemoveMobile.classList.toggle('btn-show', window.innerWidth <= 700);

    if (fit) {
        handleFitSuccess([fitSuccess, mobileFitSuccess], productFitment);
    } else {
        handleFitFailure([fitDanger, mobileFitDanger], productType);
    }
}

    // Handle click event for mobile remove button
    bikeRemoveMobile.addEventListener('click', function() {
        ['bikeName', 'searchTerm', 'fitments'].forEach(key => sessionStorage.removeItem(key));
        window.location.reload();
    });
}

function handleFitSuccess(elements, fitment) {
    fitDanger.classList.add('hide');
    elements.forEach(el => {
        el.classList.add('btn-show');
        if (fitment === '85-1001') {
            el.src = 'https://cdn.shopify.com/s/files/1/0097/0506/2447/files/Fitment-Unassigned-Icon-2.svg?v=1711033967';

        } else if (fitment === '90-1001') {
            el.src = 'https://cdn.shopify.com/s/files/1/0097/0506/2447/files/Universal-Fit-Icon-2.svg?v=1711033967';
        } else if (fitment === '95-1001') {
          el.classList.remove('btn-show');
            //el.src = 'https://cdn.shopify.com/s/files/1/0097/0506/2447/files/Universal-Fit-Icon-2.svg?v=1711033967';
        } else {
            el.src = 'https://cdn.shopify.com/s/files/1/0097/0506/2447/files/Fits-Icon-2.svg?v=1711033967';
        }
        // Apply mobile-specific styles if necessary
        if (el.id.includes('mobile')) {
            el.classList.add('mobile-fit');
        }
    });
}

function handleFitFailure(elements, productType) {
    if (["Fab Parts", "Motorcycle Parts"].includes(productType)) {
        elements.forEach(el => {
            el.classList.add('btn-show');
            el.src = 'https://cdn.shopify.com/s/files/1/0097/0506/2447/files/Doesnt-Fit-Icon-2.svg?v=1711033967';
        });
    }
}
